import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";
import { G_DARK, Field, Input, Btn, globalStyles } from "../components/Shared";

export default function ForgotPage() {
  const [email, setEmail]     = useState("");
  const [busy, setBusy]       = useState(false);
  const [error, setError]     = useState(null);
  const [message, setMessage] = useState(null);

  const handleSubmit = async e => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const res = await api.post("/auth/forgot-account", { email });
      setMessage(res.message);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f5f5f5", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans', sans-serif", padding: 24 }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=JetBrains+Mono:wght@400;600&display=swap" rel="stylesheet" />
      <style>{globalStyles}</style>

      <div style={{ maxWidth: 400, width: "100%" }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <img src="/csm_binf.png" alt="BOKU Core Facility Bioinformatics" style={{ height: 60, borderRadius: 12, marginBottom: 16 }} />
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: "#1a1a1a" }}>Account Recovery</h1>
          <p style={{ margin: "6px 0 0", fontSize: 14, color: "#6b7280" }}>BOKU Core Facility Bioinformatics</p>
        </div>

        <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 16, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
          <div style={{ padding: 28 }}>
            {message ? (
              <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
                <div style={{ padding: "10px 14px", borderRadius: 8, background: "rgba(0,150,64,0.08)", border: "1px solid rgba(0,150,64,0.25)", color: G_DARK, fontSize: 13 }}>
                  {message}
                </div>
                <Link to="/login" style={{ fontSize: 13, color: G_DARK, textDecoration: "none", fontWeight: 500, textAlign: "center" }}>
                  ← Back to sign in
                </Link>
              </div>
            ) : (
              <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 18 }}>
                <p style={{ margin: 0, fontSize: 13, color: "#6b7280" }}>
                  Enter the e-mail address you sign in with. If it belongs to an account, we'll send a link to reset its password.
                </p>
                <Field label="Email" required>
                  <Input
                    autoFocus
                    type="email"
                    autoComplete="email"
                    placeholder="you@example.org"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />
                </Field>

                {error && (
                  <div role="alert" style={{ padding: "10px 14px", borderRadius: 8, background: "rgba(220,38,38,0.06)", border: "1px solid rgba(220,38,38,0.25)", color: "#b91c1c", fontSize: 13 }}>
                    {error}
                  </div>
                )}

                <Btn type="submit" disabled={busy || !email} style={{ width: "100%", justifyContent: "center", padding: "11px 0" }}>
                  {busy ? "Sending…" : "Send recovery email"}
                </Btn>

                <Link to="/login" style={{ fontSize: 13, color: "#6b7280", textDecoration: "none", textAlign: "center" }}>
                  ← Back to sign in
                </Link>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
